<h1 class="stock-title">Stock - Open Requests</h1>

<app-breadcrumb></app-breadcrumb>

<br />
<div class="mt-3"></div>
<br />
<br />
<div class="content_bg styled-section">
  <table class="scrollable-table">
    <ds-tabs>
      <ds-tabs-label
        for="pending"
        (click)="onPendingTabClick(); $event.preventDefault()"
      >
        Pending
      </ds-tabs-label>
      <div class="mt-3"></div>

      <ds-tabs-content id="pending">
        <div class="tab-content">
          <div *ngIf="showResults; else notYetSearched">
            <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
              <div class="table-section">
                <div class="table-scroll-container">
                  <table *ngIf="rowsData.length > 0" class="ds-table zebra-table fixed-header-table">
                    <thead class="table-head">
                    <tr>
                      <th>VIN</th>
                      <th>Model Code</th>
                      <th>Description</th>
                      <th>Date Requested</th>
                      <!--            <th></th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr
                      *ngFor="let row of rowsData"
                      [ngClass]="{
                campaignitem: row['deliveryStop'] === 'Y',
                deliverystopitem: row['deliveryStop'] === 'R',
              }"
                    >

                      <td>
                        <a
                          [href]="row['VIN'] | unitOverviewLink"
                          target="_blank"
                          rel="noopener"
                          style="
                    font-weight: bold;
                    color: #037493;
                    text-decoration: none;
                    cursor: pointer;
                  "
                          title="View Unit Overview"
                        >
                          {{ row['VIN'] }}
                        </a>
                      </td>

                      <td>{{ row['modelCode'] }}</td>
                      <td>{{ row['description'] }}</td>
                      <td>{{ row['dateRequested'] }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ds-tabs-content>

      <ds-tabs-label
        for="accepted"
        (click)="onAcceptedTabClick(); $event.preventDefault()"
      >
        Accepted
      </ds-tabs-label>
      <ds-tabs-content id="accepted">
        <div class="tab-content">
          <div *ngIf="showResults; else notYetSearched">
            <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
              <div class="table-section">
                <div class="table-scroll-container">
                  <table *ngIf="rowsData.length > 0" class="ds-table zebra-table">
                    <thead>
                    <tr>
                      <th>Image</th>
                      <th>VIN</th>
                      <th>Model Code</th>
                      <th>Description</th>
                      <th>Date Requested</th>
                      <!--            <th></th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of rowsData">
                      <td>
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row['image'] || 'image placeholder'"
                            alt="Image"
                            width="80"
                          />
                          <div class="image-hover-popup">
                            <img [src]="row['image']" alt="Vehicle Enlarged View" />
                          </div>
                        </div>
                      </td>

                      <td>
                        <a
                          [href]="row['VIN'] | unitOverviewLink"
                          target="_blank"
                          rel="noopener"
                          style="
                    font-weight: bold;
                    color: #037493;
                    text-decoration: none;
                    cursor: pointer;
                  "
                          title="View Unit Overview"
                        >
                          {{ row['VIN'] }}
                        </a>
                      </td>

                      <td>{{ row['modelCode'] }}</td>
                      <td>{{ row['description'] }}</td>
                      <td>{{ row['dateRequested'] }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ds-tabs-content>

      <ds-tabs-label
        for="rejected"
        (click)="onRejectedTabClick(); $event.preventDefault()"
      >
        Rejected
      </ds-tabs-label>
      <ds-tabs-content id="rejected">
        <div class="tab-content">
          <div *ngIf="showResults; else notYetSearched">
            <ng-container *ngIf="rowsData && rowsData.length > 0; else noStock">
              <div class="table-section">
                <div class="table-scroll-container">
                  <table *ngIf="rowsData.length > 0" class="ds-table zebra-table">
                    <thead>
                    <tr>
                      <th>Image</th>
                      <th>VIN</th>
                      <th>Model Code</th>
                      <th>Description</th>
                      <th>Date Requested</th>
                      <!--              <th></th>-->
                    </tr>
                    </thead>
                    <tbody>
                    <tr *ngFor="let row of rowsData">
                      <td>
                        <div class="image-popup-wrapper">
                          <img
                            [src]="row['image'] || 'image placeholder'"
                            alt="Image"
                            width="80"
                          />
                          <div class="image-hover-popup">
                            <img [src]="row['image']" alt="Vehicle Enlarged View" />
                          </div>
                        </div>
                      </td>
                      <td>
                        <a
                          [href]="row['VIN'] | unitOverviewLink"
                          target="_blank"
                          rel="noopener"
                          style="
                      font-weight: bold;
                      color: #037493;
                      text-decoration: none;
                      cursor: pointer;
                    "
                          title="View Unit Overview"
                        >
                          {{ row['VIN'] }}
                        </a>
                      </td>
                      <td>{{ row['modelCode'] }}</td>
                      <td>{{ row['description'] }}</td>
                      <td>{{ row['dateRequested'] }}</td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </ng-container>
          </div>
        </div>
      </ds-tabs-content>
    </ds-tabs>
  </table>
</div>

<br />
<div class="mt-3"></div>
<br />
<ng-template #notYetSearched>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS YET</h1>
      <p style="margin: 0">
        Use the filters and click 'Search' to find what you need.
      </p>
    </div>
  </div>
</ng-template>
<ng-template #noStock>
  <div
    class="no-data-message"
    style="
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45vh;
      min-height: 450px;
      text-align: center;
      padding-left: 2rem;
    "
  >
    <div>
      <h1 style="margin: 0">NO SEARCH RESULTS FOUND</h1>
      <p style="margin: 0"></p>
    </div>
  </div>
</ng-template>
